import localforage from "localforage";
import { atom } from "recoil";

export const aiAssistDisclaimerAcceptedAtom = atom<boolean>({
  key: "aiAssistDisclaimerAcceptedAtom",
  default: false,
  effects: [
    ({ onSet, setSelf, trigger }) => {
      const loadState = async () => {
        try {
          const data = await localforage.getItem<boolean>("aiAssistDisclaimerAccepted");
          data ? setSelf(Boolean(data)) : setSelf(false);
        } catch (error) {
          console.log(error);
          setSelf(false);
        }
      };

      if (trigger === "get") {
        loadState();
      }

      onSet(async (newValue, _oldValue, isReset) => {
        if (isReset) {
          setSelf(false);
          await localforage.removeItem("aiAssistDisclaimerAccepted");
        } else if (newValue !== undefined) {
          await localforage.setItem("aiAssistDisclaimerAccepted", newValue);
        }
      });
    },
  ],
});
